import React from 'react';
import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

interface RulesProps {
    isOpen: boolean;
    closeModal?: () => void;
}


const Rules: React.FC<RulesProps> = ({ isOpen, closeModal }) => {
    const { t } = useTranslation();

    return (
        <>
            <Modal
                open={isOpen}
                onCancel={closeModal}
                title={t("rules")}
                footer={[
                    <Button key="close" onClick={closeModal}>
                        {t("close")}
                    </Button>,
                ]}
            >
                <div className='flex flex-col gap-4'>
                    <p>{t("rule_1")}</p>
                    <p>{t("rule_2")}</p>
                    <p>{t("rule_3")}</p>
                    <p dangerouslySetInnerHTML={{ __html: t('rule_4') }} />
                    <p>{t("rule_5")}</p>
                    <p>{t("rule_6")}</p>
                    <p>{t("rule_7")}</p>
                    {t("rule_8") ? <p>{t("rule_8")}</p> : ""}
                </div>
            </Modal>
        </>
    );
};

export default Rules;
